import { useState } from "react";
import { Sparkles } from "lucide-react";

import { Button } from "@/components/ui/button";
import { CaixaPlaybook } from "./CaixaPlaybook";
import type { AlvoPlaybook } from "./playbook";

/** O botão com o ícone de IA; "Prospecção" na ficha do contato, "Playbook" nas propostas. */
export const IconePlaybook = Sparkles;

/**
 * Botão que é dono da própria caixinha. Serve onde o botão não some enquanto
 * se conversa (a ficha do contato, também dentro do lead). Em lista paginada
 * ou em Sheet que fecha, o estado mora na tela — use `CaixaPlaybook` direto.
 */
export const BotaoPlaybook = ({ alvo, className }: { alvo: AlvoPlaybook; className?: string }) => {
  const [aberto, setAberto] = useState(false);
  return (
    <>
      <Button type="button" variant="outline" className={className} onClick={() => setAberto(true)}>
        <IconePlaybook className="text-primary" />
        {alvo.tipo === "contato" ? "Prospecção" : "Playbook"}
      </Button>
      {aberto && <CaixaPlaybook alvo={alvo} aoFechar={() => setAberto(false)} />}
    </>
  );
};
